/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 * The load of the docker container when the log entry was created.
 * @export
 * @interface DockerRunLogDockerLoad
 *
 */
// create custom validators for the regexes
export interface DockerRunLogDockerLoad {
    /**
     * The cpu usage in percent.
     * #type number
     * #memberof DockerRunLogDockerLoad
        
    * @minimum 0
        * @maximum 100
        
         */
    cpu?: number;
    /**
     * The memory usage in percent.
     * #type number
     * #memberof DockerRunLogDockerLoad
        
    * @minimum 0
        * @maximum 100
        
         */
    mem?: number;
}
/**
 * Check if a given object implements the DockerRunLogDockerLoad interface.
 */
export function instanceOfDockerRunLogDockerLoad(value: object): boolean {
    let isInstance = true;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const DockerRunLogDockerLoadTypiaAssertEquals = (input: any) => {
    return ((input: any): DockerRunLogDockerLoad => {
        const __is = (input: any, _exceptionable: boolean = true): input is DockerRunLogDockerLoad => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.cpu || "number" === typeof input.cpu && 0 <= input.cpu && 100 >= input.cpu) && (undefined === input.mem || "number" === typeof input.mem && 0 <= input.mem && 100 >= input.mem) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["cpu", "mem"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && false === Array.isArray(input) && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerRunLogDockerLoad => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.cpu || "number" === typeof input.cpu && (0 <= input.cpu || $guard(_exceptionable, {
                    path: _path + ".cpu",
                    expected: "number (@minimum 0)",
                    value: input.cpu
                })) && (100 >= input.cpu || $guard(_exceptionable, {
                    path: _path + ".cpu",
                    expected: "number (@maximum 100)",
                    value: input.cpu
                })) || $guard(_exceptionable, {
                    path: _path + ".cpu",
                    expected: "(number | undefined)",
                    value: input.cpu
                })) && (undefined === input.mem || "number" === typeof input.mem && (0 <= input.mem || $guard(_exceptionable, {
                    path: _path + ".mem",
                    expected: "number (@minimum 0)",
                    value: input.mem
                })) && (100 >= input.mem || $guard(_exceptionable, {
                    path: _path + ".mem",
                    expected: "number (@maximum 100)",
                    value: input.mem
                })) || $guard(_exceptionable, {
                    path: _path + ".mem",
                    expected: "(number | undefined)",
                    value: input.mem
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["cpu", "mem"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input && false === Array.isArray(input) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunLogDockerLoad",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunLogDockerLoad",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const DockerRunLogDockerLoadTypiaAssertStringify = (input: DockerRunLogDockerLoad): string => {
    return ((input: any): string => { const assert = (input: any): DockerRunLogDockerLoad => {
        const __is = (input: any): input is DockerRunLogDockerLoad => {
            const $io0 = (input: any): boolean => (undefined === input.cpu || "number" === typeof input.cpu && 0 <= input.cpu && 100 >= input.cpu) && (undefined === input.mem || "number" === typeof input.mem && 0 <= input.mem && 100 >= input.mem);
            return "object" === typeof input && null !== input && false === Array.isArray(input) && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerRunLogDockerLoad => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.cpu || "number" === typeof input.cpu && (0 <= input.cpu || $guard(_exceptionable, {
                    path: _path + ".cpu",
                    expected: "number (@minimum 0)",
                    value: input.cpu
                })) && (100 >= input.cpu || $guard(_exceptionable, {
                    path: _path + ".cpu",
                    expected: "number (@maximum 100)",
                    value: input.cpu
                })) || $guard(_exceptionable, {
                    path: _path + ".cpu",
                    expected: "(number | undefined)",
                    value: input.cpu
                })) && (undefined === input.mem || "number" === typeof input.mem && (0 <= input.mem || $guard(_exceptionable, {
                    path: _path + ".mem",
                    expected: "number (@minimum 0)",
                    value: input.mem
                })) && (100 >= input.mem || $guard(_exceptionable, {
                    path: _path + ".mem",
                    expected: "number (@maximum 100)",
                    value: input.mem
                })) || $guard(_exceptionable, {
                    path: _path + ".mem",
                    expected: "(number | undefined)",
                    value: input.mem
                }));
                return ("object" === typeof input && null !== input && false === Array.isArray(input) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunLogDockerLoad",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunLogDockerLoad",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: DockerRunLogDockerLoad): string => {
        const $tail = (typia.createAssertStringify as any).tail;
        const $so0 = (input: any): any => `{${$tail(`${undefined === input.cpu ? "" : `"cpu":${undefined !== input.cpu ? input.cpu : undefined},`}${undefined === input.mem ? "" : `"mem":${undefined !== input.mem ? input.mem : undefined}`}`)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const DockerRunLogDockerLoadValidatorShape = {
    'cpu': yup.number().min(0).max(100),
    'mem': yup.number().min(0).max(100),
};
export const DockerRunLogDockerLoadValidator = yup.object().shape(DockerRunLogDockerLoadValidatorShape);
export const DockerRunLogDockerLoadStringifyShapeProperties: ObjectSchema['properties'] = {
    'cpu': {
        'type': 'number',
        'minimum': 0,
        'maximum': 100,
    } as unknown as fastJSON.NumberSchema,
    'mem': {
        'type': 'number',
        'minimum': 0,
        'maximum': 100,
    } as unknown as fastJSON.NumberSchema,
};
export const DockerRunLogDockerLoadStringifyShape: ObjectSchema = {
    title: 'DockerRunLogDockerLoad Stringifier',
    type: 'object',
    properties: {
        ...DockerRunLogDockerLoadStringifyShapeProperties
    },
    required: [],
};
export const DockerRunLogDockerLoadStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DockerRunLogDockerLoadStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const DockerRunLogDockerLoadStringify: (data: DockerRunLogDockerLoad) => string = DockerRunLogDockerLoadStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function DockerRunLogDockerLoadFromJSON(json: any): DockerRunLogDockerLoad {
    return DockerRunLogDockerLoadFromJSONTyped(json, false);
}
export function DockerRunLogDockerLoadFromJSONTyped(json: any, ignoreDiscriminator: boolean): DockerRunLogDockerLoad {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'cpu': !exists(json, 'cpu') ? undefined : json['cpu'],
        'mem': !exists(json, 'mem') ? undefined : json['mem'],
    };
}
export function DockerRunLogDockerLoadToJSON(value?: DockerRunLogDockerLoad | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'cpu': value.cpu,
        'mem': value.mem,
    };
}
